module.exports = __webpack_public_path__ + "static/media/altel.8de94d28.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/payment/kz_pay/altel.svg
// module id = 881
// module chunks = 7